<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'
import SearchFilterItem from './SearchFilterItem'

const props = defineProps({
    viewId: String
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed properties
const filters = computed(() => {
    return viewStore.filters || []
})

const savedFilters = computed(() => {
    return viewStore.savedFilters || []
})
</script>

<template>
    <form class="form form-inline" role="search" @submit.prevent>
        <!-- Updated :key to use a unique object property instead of index 'i' to prevent element mixing on delete -->
        <SearchFilterItem
            v-for="(filter, i) in filters"
            :key="filter.id || `${filter.columnName}-${filter.type}-${i}`"
            :view-id="viewId"
            :filterKey="i"
        />

        <!--<pre class="small"><small>{{ filters }}</small></pre>
        <pre class="small"><small>{{ savedFilters }}</small></pre>-->
    </form>
</template>